import { application } from './application.js'

import ClipboardController from './clipboard_controller.js';
import FormSubmitController from './form_submit_controller.js';
import OpenedModalController from './opened_modal_controller.js';
import PayoutAmountController from './payout_amount_controller.js';
import PerformanceChartController from './performance_chart_controller.js';
import ProjectsCarouselController from './projects_carousel_controller.js';
import RentalIncomeChartController from './rental_income_chart_controller.js';
import ReservationController from './reservation_controller.js';
import RowLinkController from './row_link_controller.js';

application.register('clipboard', ClipboardController);
application.register('form-submit', FormSubmitController);
application.register('opened-modal', OpenedModalController);
application.register('payout-amount', PayoutAmountController);
application.register('performance-chart', PerformanceChartController);
application.register('projects-carousel', ProjectsCarouselController);
application.register('rental-income-chart', RentalIncomeChartController);
application.register('reservation', ReservationController);
application.register('row-link', RowLinkController);
